/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  fieldset: {
    margin: [rem(32, baseFontSize), 0],
    padding: 0,

    border: 'none',
  },
};
